// extracted by mini-css-extract-plugin
export default {"expertTeam":"ExpertTeam_expertTeam__jUNgJ","loadMargin":"ExpertTeam_loadMargin__2dafe","teamMembers":"ExpertTeam_teamMembers__0QAxG","teamMember":"ExpertTeam_teamMember__D8V7-"};